{
    "Capability": "Fähigkeit",
    "CapabilityEnabled": "Aktiviert",
    "AvailableTelServers": "Welche Telefonie-Server-Typen gibt es?",
    "AvailableLicences": "Welche Arten von Standortlizenzen gibt es?",
    "Broadworks": "Cisco Broadworks",
    "Webex": "Webex-Anrufe",
    "LegacyTelephony": "Altbestand ^^(Broadsoft M6, Panasonic, Siemens)^^",
    "Legacy": "Vermächtnis ^^(ONE, Presence, Lite, 1000, 2000)^^",
    "Enterprise": "Unternehmen",
    "Teams": "MS-Teams",
    "MaxTelsysCount": "Maximale Anzahl von Telephony-Servern in diesem CME",
    "NAME": "CMECapabilities",
    "CxAnalytics": "CX-Analyse",
    "CxIntegration": "CX-Integration"
}